import {
  Component,
  HostListener,
  Inject,
  Input,
  OnInit, PLATFORM_ID
} from '@angular/core';
import {DOCUMENT, isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'app-page-template',
  templateUrl: './page-template.component.html',
  styleUrls: ['./page-template.component.scss']
})
export class PageTemplateComponent implements OnInit {
  @Input() isLanding: boolean = false;
  @Input() showBreadcrumbs: boolean = true;
  currentWindowWidth: number = 0;
  showHeader:boolean = true;

  constructor(@Inject(DOCUMENT) private document: Document, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformBrowser(this.platformId)) {
      this.currentWindowWidth = window.innerWidth;
    }
  }

  ngOnInit(): void {
    if (this.document.location.href.includes("admin")) {
      this.showHeader = false;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.currentWindowWidth = event.target.innerWidth;
  }
}
